module.exports = __webpack_public_path__ + "images/category_lp/tablet/point3_63b07b4f2986e7986106174432691f19.png";